<template>
	<div>
		<minhead :headtitle="headtitle"></minhead>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown topspan">
					<span>网络发票未分发信息</span>
				</div>
				<div class="Centerupdown">
					<el-input style="width: 300px;margin-left: 20px;margin-right: 16px;" placeholder="发票代码、发票号码、发票类型" prefix-icon="el-icon-search" clearable v-model="unSerchval" @input="unDistributeChangeSerch"></el-input>
				</div>
			</div>
			<div class="areatable">
				<el-table :data="unDistributeTableData" border style="width: 100%" height="200" @row-click="clickUnDistributeRowByChecked">
					<el-table-column prop="faplxdm" label="发票类型"  align="center" min-width="100" :formatter="formaterFalxdm"></el-table-column>
					<el-table-column prop="fapdm" label="发票代码"  align="left" min-width="160px" show-overflow-tooltip></el-table-column>
					<el-table-column prop="qishm" label="发票起号"  align="left" min-width="160px" show-overflow-tooltip></el-table-column>
					<el-table-column prop="zhongzhm" label="发票止号"  align="left" min-width="160px" show-overflow-tooltip></el-table-column>
					<el-table-column prop="fapfs" label="发票份数"  align="center" min-width="100"></el-table-column>
					<el-table-column prop="shengyfs" label="剩余份数" align="center" min-width="100"></el-table-column>
					<el-table-column prop="qtxx" label="其他信息"   align="left" min-width="160px" show-overflow-tooltip></el-table-column>
				</el-table>
		
				<div class="buttompage">
					<el-pagination
						@size-change="unHandleSizeChange"
						@current-change="unHandleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="unPagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="unTotalcount"
					></el-pagination>
				</div>
			</div>

			<div class="halfkuang ">
                <el-form :model="docDistributForm" :rules="docDistributRules" ref="docDistributForm" class="demo-ruleForm" style="padding-left: 20px;">
                    <div class="Centerupdown">
                        <el-form-item label="发票类型:" prop="faplxdm" :label-width="formLabelWidth">
                            <el-select v-bind:disabled="docDistributFormReadonly" style="width: 120px;" value="" v-model="docDistributForm.faplxdm">
                                <el-option label="电子普票" value="026"></el-option>
                                <el-option label="电子专票" value="028"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发票代码:" prop="fapdm" :label-width="formLabelWidth">
                            <el-input v-bind:disabled="docDistributFormReadonly" style="width: 120px;"  v-model="docDistributForm.fapdm"></el-input>
                        </el-form-item>
                        <el-form-item label="发票起号:" prop="qishm" :label-width="formLabelWidth">
                            <el-input  v-bind:disabled="docDistributFormReadonly" style="width: 120px;"   v-model="docDistributForm.qishm"></el-input>
                        </el-form-item>
                        <el-form-item label="发票止号:" prop="zhongzhm" :label-width="formLabelWidth">
                            <el-input v-bind:disabled="docDistributFormReadonly" style="width: 120px;"  v-model="docDistributForm.zhongzhm"></el-input>
                        </el-form-item>
                    </div>

                    <div  class="Centerupdown">
                        <el-form-item label="发票份数:" prop="fapfs" :label-width="formLabelWidth">
                            <el-input v-bind:disabled="docDistributFormReadonly" style="width: 120px;"   v-model="docDistributForm.fapfs"></el-input>
                        </el-form-item>
                        <el-form-item label="剩余份数:" prop="shengyfs" :label-width="formLabelWidth">
                            <el-input v-bind:disabled="docDistributFormReadonly" style="width: 120px;"  v-model="docDistributForm.shengyfs"></el-input>
                        </el-form-item>
                        <el-form-item label="分发份数:" prop="fenffs" :label-width="formLabelWidth">
                            <el-input-number :min="1"  style="width: 120px;" v-model="docDistributForm.fenffs" @input="invalidFenffs"></el-input-number>
                        </el-form-item>
                        <el-form-item label="开票点:" prop="kaipzddm" :label-width="formLabelWidth">
                            <el-select style="width: 120px;" value="" v-model="docDistributForm.kaipzddm">
                                <el-option v-for="item in curQiyKaipj" :key="item.kaipjbh" :label="item.kaipjmc"
                                           :value="item.kaipjbh"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
				<div class="fenfa" @click="submitForm('docDistributForm')">分发</div>
			</div>
		</div>
		<div class="areacontent">
			<div class="between-line">
                <div class="Centerupdown topspan">
                    <span>网络发票已分发信息</span>
                </div>
				<div class="Centerupdown">
					<el-input style="width: 300px;margin-left: 20px;margin-right: 16px;" placeholder="发票代码、发票号码、开票点、发票类型" prefix-icon="el-icon-search" v-model="serchval" @input="distributeChangeSerch"></el-input>
				</div>
			</div>
			<div class="areatable">
				<el-table :data="distributeTableData" border style="width: 100%" height="200" @row-click="clickDistributeRowByChecked">
					<el-table-column prop="faplxdm" label="发票类型"  align="center" min-width="100" :formatter="formaterFalxdm"></el-table-column>
					<el-table-column prop="fapdm" label="发票代码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
					<el-table-column prop="qishm" label="发票起号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
					<el-table-column prop="zhongzhm" label="发票止号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
					<el-table-column prop="fapfs" label="分发份数"  align="center" min-width="100"></el-table-column>
                    <el-table-column prop="shengyfs" label="剩余份数" align="center" min-width="100"></el-table-column>
				</el-table>

				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			/* 开具弹框 */ 
			page: 1,
			pagenum: 10,
			totalcount: 10,
            distributeTableData: [],
            unDistributeTableData: [],
            unPage: 1,
            unPagenum: 10,
            unTotalcount: 10,
			headtitle: ['库存管理', '发票网上分发'],
			serchval: '',
            unSerchval:'',
            docDistributForm: {
                faplxdm: '',
                fapdm: '',
                qishm: '',
                zhongzhm: '',
                fapfs:'',
                shengyfs: '',
                fenffs: '',
                kaipzddm:''
            },
            docDistributRules: {
                kaipzddm: [{ required: true, message: '请选择开票终端代码', trigger: 'blur' }],
                fenffs: [{ required: true, message: '请输入分发份数', trigger: 'blur' }],
                faplxdm: [{ required: true, message: '请先选择未分发信息', trigger: 'blur' }],
                fapdm: [{ required: true, message: '请先选择未分发信息', trigger: 'blur' }],
                qishm: [{ required: true, message: '请先选择未分发信息', trigger: 'blur' }],
                zhongzhm: [{ required: true, message: '请先选择未分发信息', trigger: 'blur' }],
                fapfs: [{ required: true, message: '请先选择未分发信息', trigger: 'blur' }],
                shengyfs: [{ required: true, message: '请先选择未分发信息', trigger: 'blur' }]
            },
            formLabelWidth:'150px',
            docDistributFormReadonly: true,
            curQiyKaipj:[]
		};
	},
	created() {
        this.getDocDistributeList();
        this.getDocUnDistributeList();
        this.getCurQiyKaipj();
    },
	methods: {
        /* 搜索 */
        distributeChangeSerch(e) {
            this.serchval = e;
            this.getDocDistributeList();
        },unDistributeChangeSerch(e) {
            this.unSerchval = e;
            this.getDocUnDistributeList();
        },
        unHandleSizeChange(val) {
            this.unPagenum = val;
            this.getDocUnDistributeList();
        },
		handleSizeChange(val) {
			this.pagenum = val;
            this.getDocDistributeList();
		},
        unHandleCurrentChange(val) {
            this.unPage = val;
            this.getDocUnDistributeList();
        },
		handleCurrentChange(val) {
			this.page = val;
            this.getDocDistributeList();
		},getDocDistributeList() {
            let params = {
                likeSearch:this.serchval,
                page: this.page,
                limit: this.pagenum,
                sort: "asc",
                order: "id",

            };
            this.$https.fetchPost('/inventory/getDocDistributeList', params).then(res => {
                console.log(res);
                this.distributeTableData = res.data.data;
                this.totalcount = res.data.count;
            })
        },getDocUnDistributeList() {
            let params = {
                likeSearch:this.unSerchval,
                page: this.unPage,
                limit: this.unPagenum,
                sort: "asc",
                order: "id",
            };
            this.$https.fetchPost('/inventory/getDocUnDistributeList', params).then(res => {
                console.log(res);
                this.unDistributeTableData = res.data.data;
                this.unTotalcount = res.data.count;
            })
        }
        //未分发数据点击事件
        ,clickUnDistributeRowByChecked(row){
            this.docDistributForm=JSON.parse(JSON.stringify(row));
        },clickDistributeRowByChecked(){

        },formaterFalxdm(row)
        {
            let result=row.faplxdm;
            switch(row.faplxdm)
            {
                case "026":
                    result="电子普票";
                    break;
                case "028":
                    result="电子专票";
                    break;
            }
            return result;
        },submitForm(formName)
        {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (formName === "docDistributForm") {
                        this.doSubmitDocDistributForm();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },doSubmitDocDistributForm()
        {
            let param=this.docDistributForm;
            console.log("params:"+JSON.stringify(param));
            this.$https.fetchPost('/inventory/doDocDistribute', param).then(res => {
                if (res.data.success) {
                    this.getDocDistributeList();
                    this.getDocUnDistributeList();
                    this.$message.success(this.$tolertJSON['019-1']);
                    this.$refs["docDistributForm"].resetFields();
                }
            });
        },invalidFenffs()
        {
            if(parseInt(this.docDistributForm.fenffs)>parseInt(this.docDistributForm.shengyfs))
            {
                this.docDistributForm.fenffs=this.docDistributForm.shengyfs;
            }
        },getCurQiyKaipj()
        {
            this.$https.fetchPost('inventory/getCurQiyKaipj').then(res => {
                this.curQiyKaipj = res.data.obj;
            });
        }
	}
};
</script>

<style scoped="scoped" lang="less">
	.fenfa:extend(.Centerhorizontally){
		width: 66px;
		height: 25px;
		background: #2F66FC;
		color: white;
		cursor: pointer;
		opacity: 1;
		border-radius: 2px;
		
		

	}
	
	.halfkuang{
		width: 98%;
		height: 100px;
		font-size: 14px;
		display: flex;
		align-items: center;
		font-weight: 400;
		color: #333333;
		margin-top: 30px;
		padding-top: 30px;
		padding-bottom: 20px;
		margin-bottom: 30px;
border: 1px solid #E5E5E5;
	}
	.halfkuang>div>div{
		margin-bottom: 10px;
	}
/deep/.el-dialog__body {
	padding: 0;
}
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}

/deep/.el-dialog__header {
	display: none;
}
.topspan>span{
	font-size: 17px;
	color: #0080FF;
}
.areatable {
	margin-top: 27px;
}
.areacontent {
	margin-left: 21px;
}
</style>
